// RequestDeleteModal.js
import React from 'react';
import './DeleteRequest.css'; 

const RequestDeleteModal = ({ show, onClose, onConfirm, request }) => {
  if (!show) {
    return null;
  }

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <p>Are you sure you want to delete this request?</p>
        {request && (
          <div>
            <p><strong>URL:</strong> {request.url}</p>
            <p><strong>Message:</strong> {request.message}</p>
            <p><strong>Details:</strong> {request.details}</p>
            <p><strong>Email:</strong> {request.email}</p>
          </div>
        )}
        <div className="modal-buttons">
          <button className="modal-button confirm-button" onClick={onConfirm}>Yes</button>
          <button className="modal-button cancel-button" onClick={onClose}>No</button>
        </div>
      </div>
    </div>
  );
};

export default RequestDeleteModal;
